/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store";

interface IState {
  pos: Tpos
  data: any
}

type Tpos = { x: number, y: number } | null
const initialState: IState = {
  pos: null,
  data: null
} as IState

const slice = createSlice({
  name: 'globalRightClickMenuSlice',
  initialState,
  reducers: {
    setGlobalRightClickMenuPosition: (state, action: PayloadAction<Tpos>) => void (state.pos = action.payload),
    setGlobalRightClickMenuData: (state, action: PayloadAction<any>) => void (state.data = action.payload),
  }
})

const selectGlobalRightClickMenuState = (state: RootState) => state.globalRightClickMenu

const {actions, reducer} = slice
export {
  selectGlobalRightClickMenuState
}
export const {
  setGlobalRightClickMenuPosition,
  setGlobalRightClickMenuData
} = actions

export default reducer
